export function SpinnerCog(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="8rem"
      height="8rem"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.5 0h3l.75 4.5l1.28.53l3.97-2.56l2.03 2.03l-2.56 3.97l.53 1.28l4.499.75v3l-4.5.75l-.53 1.28l2.56 3.97l-2.03 2.03l-3.97-2.56l-1.28.53l-.75 4.499h-3l-.75-4.5l-1.28-.53l-3.97 2.56l-2.031-2.03l2.56-3.97l-.53-1.28l-4.499-.75v-3l4.5-.75l.53-1.28l-2.56-3.97l2.03-2.031l3.97 2.56l1.28-.53zM12 7.5a4.5 4.5 0 1 0 0 9a4.5 4.5 0 0 0 0-9"
      ></path>
    </svg>
  )
}
